import { Tables } from '../../../../../../modules/API/Tables/Tables'
import { ITableDataProvider } from '../../../../../../generic/universal-table/types/data-provider.types'
import { packageTableAdapter } from '../adapters/packageTable.adapter'
import {
  PackageCreatePayload,
  PackageUiRow,
  PackageUpdatePayload,
} from '../types/packageTable.types'

export const packageTableService: ITableDataProvider<
  PackageUiRow,
  PackageCreatePayload,
  PackageUpdatePayload
> = {
  getList: async (): Promise<PackageUiRow[]> => {
    const rows = await Tables.getPackageList()
    return rows.map(packageTableAdapter.fromApi)
  },

  create: async (payload: PackageCreatePayload): Promise<PackageUiRow> => {
    const created = await Tables.createPackage(payload)
    return packageTableAdapter.fromApi(created)
  },

  update: async (
    id: number | string,
    payload: PackageUpdatePayload
  ): Promise<PackageUiRow> => {
    const updated = await Tables.updatePackage(Number(id), payload)
    return packageTableAdapter.fromApi(updated)
  },

  remove: async (id: number | string): Promise<void> => {
    await Tables.deletePackage(Number(id))
  },
}
